// extracted by mini-css-extract-plugin
export default {"primary-btn":"WheelzButton_primary-btn__pdaJJ","secondary-btn":"WheelzButton_secondary-btn__naYwH"};